<template>
    <div id="single-contact-sidebar" class="sidebar single-contact-sidebar" v-bind:class="{ closeSidebar: !collapseSidebar }">
        <div class="white-box mb-3">
            <div class="d-flex align-items-center">
                <h5 class="sibebar-title text-left text-black mr-auto">{{ $t('profile') }}</h5>
            </div>
            <div v-if="contact !== null">
                <div class="d-flex mb-3" v-if="contact.attributes['facebook-id'] !== undefined && contact.attributes['facebook-id'] != null">
                    <div class="connector-icon mr-2 facebook-connector">
                        <font-awesome-icon class="text-white" :icon="['fab', 'facebook-f']" />
                    </div>
                    <p class="mr-2 mb-0 profile-name text-left">{{ contact.attributes['facebook-name'] }}</p>
                </div>
                <div class="d-flex mb-3" v-if="contact.attributes.email != null">
                    <div class="connector-icon mr-2 innactive email">
                        <font-awesome-icon class="icon text-white" :icon="['fas', 'envelope']" />
                    </div>
                    <p class="mr-2 mb-0 profile-name text-left"><a class="contact-data" :href="'mailto:'+ contact.attributes.email" target="_blank">{{ contact.attributes.email }}</a></p>
                    <!-- Chose main information if contact has multiple one, intergration
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" id="facebook-2" name="main-account-fb" class="custom-control-input">
                        <label class="custom-control-label" for="facebook-2">Pricipal</label>
                    </div>-->
                </div>
            </div>
            <div class="d-flex mb-3" v-if="contact !== null && contact.attributes['phone-number'] != null">
                <div class="connector-icon sms-connector mr-2 innactive sms">
                    <font-awesome-icon class="icon text-white" :icon="['fas', 'mobile-alt']" />
                </div>
                <div class="overflow-hidden">
                    <p class="mr-2 mb-0 profile-name text-left"><a class="contact-data" :href="`tel:${contact.attributes['phone-number']}`">{{ formatPhoneNumber(contact.attributes["phone-number"]) }}</a></p>
                    <p v-if="isArchived" class="mb-0 fs-14 text-left text-darker-grey font-nunito-italic">{{ $t('archived-contact') }}</p>
                </div>
                <!-- Chose main information if contact has multiple one, intergration
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="number-1" name="main-account-number" class="custom-control-input" checked>
                    <label class="custom-control-label" for="number-1">Pricipal</label>
                </div>
                -->
            </div>
            <div v-if="contact !== null && !isFacebookContact" class="d-flex flex-column">
                <button type="button" class="btn btn-outline-primary rounded-pill style-btn" v-b-modal.form-edit-contact>
                    {{ $t('edit') }}
                </button>
                <button
                    v-if="isArchived"
                    type="button"
                    class="btn btn-outline-primary rounded-pill style-btn mt-2"
                    :disabled="updating"
                    @click="restoreContact()"
                >
                    {{ $t('restore') }}
                </button>
                <button
                    v-else
                    type="button"
                    class="btn btn-outline-danger rounded-pill style-btn mt-2"
                    :disabled="updating"
                    @click="archiveContact()"
                >
                    {{ $t('archive') }}
                </button>
                <form-edit-contact v-bind:contact="contact"></form-edit-contact>
            </div>
        </div>
        <div class="white-box mb-3 tags-sidebar sidebar-accordion" :class="{ 'is-open': openSection === 'tags' }">
            <button
                type="button"
                class="sidebar-accordion-toggle"
                aria-controls="contact-tags-section"
                :aria-expanded="openSection === 'tags' ? 'true' : 'false'"
                @click="toggleSection('tags')"
            >
                <h6 class="sibebar-title text-left text-black mb-0 mr-auto">
                    {{ $t('profile-tags') }}
                    <span class="sidebar-accordion-count">({{ tagsCount }})</span>
                </h6>
                <font-awesome-icon class="sidebar-accordion-arrow" :icon="['fas', 'chevron-down']" />
            </button>
            <div v-show="openSection !== 'tags' && tagsCount > 0" ref="tagsPreview" class="sidebar-tags-preview">
                <span v-for="tag in previewTags" :key="tag" class="sidebar-tags-preview-chip">{{ tag }}</span>
                <button
                    v-if="hiddenTagsCount > 0"
                    type="button"
                    class="sidebar-tags-preview-more"
                    :aria-label="$tc('more-tags', hiddenTagsCount)"
                    @click="openSection = 'tags'"
                >
                    +{{ hiddenTagsCount }}
                </button>
                <!-- Invisible copy of every tag, measured to know how many fit on the line -->
                <div ref="tagsMeasure" class="sidebar-tags-preview-measure" aria-hidden="true">
                    <span v-for="tag in tags" :key="tag" class="sidebar-tags-preview-chip">{{ tag }}</span>
                    <span class="sidebar-tags-preview-more">+{{ tagsCount }}</span>
                </div>
            </div>
            <div v-show="openSection === 'tags'" id="contact-tags-section" class="sidebar-accordion-body">
                <contact-tags :show-title="false"></contact-tags>
            </div>
        </div>
        <div class="white-box note-sidebar sidebar-accordion" :class="{ 'is-open': openSection === 'notes' }">
            <button
                type="button"
                class="sidebar-accordion-toggle"
                aria-controls="contact-notes-section"
                :aria-expanded="openSection === 'notes' ? 'true' : 'false'"
                @click="toggleSection('notes')"
            >
                <h6 class="sibebar-title text-left text-black mb-0 mr-auto">
                    {{ $t('notes') }}
                    <span class="sidebar-accordion-count">({{ notesCount }})</span>
                </h6>
                <font-awesome-icon class="sidebar-accordion-arrow" :icon="['fas', 'chevron-down']" />
            </button>
            <div v-show="openSection === 'notes'" id="contact-notes-section" class="sidebar-accordion-body">
                <contact-notes :show-title="false"></contact-notes>
            </div>
        </div>
    </div>
</template>
<script>

// Internal componants
import ContactNotes    from './ContactNotes.vue';
import ContactTags     from './ContactTags.vue';
import FormEditContact from '../contacts/FormEditContact.vue';
import Alert           from '../../../helpers/Alert.js';

// External libraries
import {
    mapState,
    mapGetters,
    mapActions
} from 'vuex';
import moment from 'moment';
import { formatPhoneNumber } from '@/libraries/PhoneNumber';

export default {
    components: {
        FormEditContact,
        ContactNotes,
        ContactTags
    },

    props: [
        'collapseSidebar',
        'contactTags'
    ],

    data () {
        return {
            updating:    false,
            openSection: null,
            previewTags: []
        };
    },

    computed: {
        ...mapState('core/contacts', {
            contact:     'single',
            singleNotes: 'singleNotes'
        }),

        ...mapGetters('core/contacts', { singleTags: 'singleTags' }),

        tags () {
            return this.singleTags || [];
        },

        tagsCount () {
            return this.tags.length;
        },

        hiddenTagsCount () {
            return this.tagsCount - this.previewTags.length;
        },

        notesCount () {
            return Object.keys(this.singleNotes || {}).length;
        },

        isArchived () {
            return this.contact !== null && this.contact.attributes['deleted-at'] !== null;
        },

        isFacebookContact () {
            return this.contact.attributes['facebook-id'] !== undefined && this.contact.attributes['facebook-id'] !== null;
        }
    },

    mounted () {
        // The preview is refilled when it is shown again or when the sidebar width changes
        this.tagsPreviewObserver = new ResizeObserver(() => this.fillTagsPreview());
        this.tagsPreviewObserver.observe(this.$refs.tagsPreview);
    },

    beforeDestroy () {
        this.tagsPreviewObserver.disconnect();
    },

    methods: {
        formatPhoneNumber,

        ...mapActions('core/contacts', [
            'patch'
        ]),

        /**
         * Fill the collapsed tags preview line with as many tags as fit, keeping room for the "+N" button.
         * Tags too long to fit are skipped so a shorter one after them can still be shown.
         */
        fillTagsPreview () {
            const preview = this.$refs.tagsPreview;
            const width   = preview.clientWidth;

            // Not displayed (tags section open or no tags)
            if (width === 0) {
                return;
            }

            const gap        = parseFloat(getComputedStyle(preview).columnGap) || 0;
            const elements   = Array.from(this.$refs.tagsMeasure.children);
            const moreWidth  = elements.pop().getBoundingClientRect().width;
            const tagWidths  = elements.map(element => element.getBoundingClientRect().width);
            const totalWidth = tagWidths.reduce((sum, tagWidth) => sum + tagWidth + gap, -gap);

            if (totalWidth <= width) {
                this.previewTags = [...this.tags];
                return;
            }

            let available = width - moreWidth;

            this.previewTags = this.tags.filter((tag, index) => {
                const fits = tagWidths[index] + gap <= available;

                if (fits) {
                    available -= tagWidths[index] + gap;
                }

                return fits;
            });
        },

        toggleSection (section) {
            this.openSection = this.openSection === section ? null : section;
        },

        /**
         * Archive the contact
         */
        archiveContact () {
            const contactId = this.contact.id;

            this.$dialog.confirm({
                title:       this.$t('archive-contact'),
                html:        this.$t('archive-contact-details'),
                centerText:  true,
                confirmText: this.$t('archive-contact'),
                danger:      true,
                onConfirm:   () => this.patch({
                    id:         contactId,
                    attributes: { 'deleted-at': moment().format() }
                })
            })
                .then((confirmed) => {
                    if (confirmed) {
                        Alert.success(this.$i18n.t('contact-is-archived'));
                    }
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                });
        },

        /**
         * Restore the archived contact
         */
        restoreContact () {
            this.updating = true;

            this.patch({
                id:         this.contact.id,
                attributes: { 'deleted-at': null }
            })
                .then(() => {
                    Alert.success(this.$i18n.t('contact-unarchived'));
                })
                .catch(() => {
                    Alert.fail(this.$i18n.t('default-error'));
                })
                .finally(() => {
                    this.updating = false;
                });
        }
    }
};
</script>
